import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  container: { display: "flex", alignItems: "flex-end", flexDirection: "column" },
  marginRight: { marginRight: theme.spacing(2) },
  marginBottom: { marginBottom: theme.spacing(1) },
}));

export default useStyles;
